// Mock data for Learn page - Digital Marketing Course

export const coursePlans = [
  {
    id: 1,
    name: "Professional Program",
    duration: "6 Months",
    price: "₹99,999",
    emi: "₹16,666/month",
    features: [
      "Complete Digital Marketing Mastery",
      "10+ Industry Projects",
      "1-on-1 Mentor Sessions (10 sessions)",
      "Job Placement Assistance",
      "Lifetime Course Access",
      "All 12 Modules Included",
      "Google, Meta & LinkedIn Certifications",
      "Capstone Project with Real Client"
    ],
    recommended: true,
    color: "#33c375"
  },
  {
    id: 2,
    name: "Foundation Program",
    duration: "3 Months",
    price: "₹49,999",
    emi: "₹16,666/month",
    features: [
      "Essential Digital Marketing Skills",
      "5 Industry Projects",
      "Group Mentorship Sessions",
      "6 Months Course Access",
      "First 6 Modules Included",
      "Google & Meta Certifications",
      "Capstone Project"
    ],
    recommended: false,
    color: "#012726"
  }
];

export const certifications = [
  {
    name: "Google Digital Marketing",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
    description: "Google Ads & Analytics Certification"
  },
  {
    name: "Meta Blueprint",
    logo: "https://upload.wikimedia.org/wikipedia/commons/b/b9/2023_Facebook_icon.svg",
    description: "Facebook & Instagram Marketing"
  },
  {
    name: "LinkedIn Marketing",
    logo: "https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png",
    description: "LinkedIn Marketing Certification"
  }
];

export const curriculum = {
  sixMonths: [
    {
      module: 1,
      title: "Digital Marketing Foundations",
      duration: "2 weeks",
      topics: [
        "Introduction to Digital Marketing Ecosystem",
        "Understanding the Digital Consumer",
        "Marketing Funnel & Customer Journey Mapping",
        "Digital Marketing Strategy Framework",
        "Tools Overview: Google Suite, Meta Suite, Analytics"
      ],
      project: "Create a complete digital marketing strategy for a startup"
    },
    {
      module: 2,
      title: "Search Engine Optimization (SEO)",
      duration: "3 weeks",
      topics: [
        "On-Page SEO: Content, Keywords, Technical SEO",
        "Off-Page SEO: Backlinks, Domain Authority",
        "Local SEO & Google My Business",
        "SEO Tools: Ahrefs, SEMrush, Google Search Console",
        "SEO Content Writing & Optimization"
      ],
      project: "Complete SEO audit and optimization plan for a website"
    },
    {
      module: 3,
      title: "Search Engine Marketing (SEM) & PPC",
      duration: "3 weeks",
      topics: [
        "Google Ads Fundamentals",
        "Campaign Structure & Ad Groups",
        "Keyword Research & Match Types",
        "Ad Copywriting & A/B Testing",
        "Bidding Strategies & Budget Optimization",
        "Google Shopping & Display Ads"
      ],
      project: "Launch and manage a Google Ads campaign with ₹10K budget"
    },
    {
      module: 4,
      title: "Social Media Marketing",
      duration: "3 weeks",
      topics: [
        "Facebook & Instagram Marketing Strategy",
        "Content Creation for Social Media",
        "Community Management & Engagement",
        "LinkedIn Marketing for B2B",
        "Twitter/X Marketing Strategies",
        "Social Media Analytics & Reporting"
      ],
      project: "Create and execute 30-day social media campaign"
    },
    {
      module: 5,
      title: "Content Marketing & Storytelling",
      duration: "2 weeks",
      topics: [
        "Content Strategy & Planning",
        "Blogging for SEO & Engagement",
        "Video Marketing & YouTube Strategy",
        "Email Marketing & Newsletter Strategy",
        "Content Calendar & Distribution",
        "AI-Powered Content Creation"
      ],
      project: "Develop complete content marketing strategy with 3-month calendar"
    },
    {
      module: 6,
      title: "Social Media Advertising",
      duration: "3 weeks",
      topics: [
        "Facebook Ads Manager Mastery",
        "Instagram Ads & Stories Ads",
        "LinkedIn Ads for B2B Lead Generation",
        "Audience Targeting & Custom Audiences",
        "Retargeting & Lookalike Audiences",
        "Ad Creative Best Practices"
      ],
      project: "Run multi-platform social media ad campaign"
    },
    {
      module: 7,
      title: "Marketing Analytics & Data-Driven Decision Making",
      duration: "2 weeks",
      topics: [
        "Google Analytics 4 (GA4) Complete Guide",
        "Conversion Tracking & Goal Setup",
        "UTM Parameters & Campaign Tracking",
        "Data Visualization with Looker Studio",
        "ROI Calculation & Marketing Attribution",
        "Marketing Dashboards & Reporting"
      ],
      project: "Build comprehensive marketing analytics dashboard"
    },
    {
      module: 8,
      title: "Email Marketing & Marketing Automation",
      duration: "2 weeks",
      topics: [
        "Email Marketing Strategy & List Building",
        "Email Copywriting & Design",
        "Marketing Automation with HubSpot/Mailchimp",
        "Lead Nurturing Workflows",
        "A/B Testing & Email Optimization",
        "CRM Integration & Lead Scoring"
      ],
      project: "Create automated email marketing funnel"
    },
    {
      module: 9,
      title: "Influencer & Affiliate Marketing",
      duration: "2 weeks",
      topics: [
        "Influencer Marketing Strategy",
        "Finding & Vetting Influencers",
        "Affiliate Marketing Programs",
        "Partnership Negotiations",
        "Campaign Management & Tracking",
        "ROI Measurement for Influencer Campaigns"
      ],
      project: "Design influencer marketing campaign for a brand"
    },
    {
      module: 10,
      title: "E-Commerce Marketing",
      duration: "2 weeks",
      topics: [
        "E-Commerce Marketing Funnel",
        "Product Page Optimization",
        "Shopping Ads & Product Feeds",
        "Cart Abandonment Strategies",
        "Amazon & Marketplace Marketing",
        "Conversion Rate Optimization (CRO)"
      ],
      project: "Complete e-commerce marketing strategy with CRO plan"
    },
    {
      module: 11,
      title: "AI in Digital Marketing",
      duration: "2 weeks",
      topics: [
        "ChatGPT for Marketing Content",
        "AI-Powered Ad Copy & Creative",
        "Marketing Automation with AI",
        "Predictive Analytics & AI Tools",
        "AI for Personalization & Customer Segmentation",
        "Future of AI in Marketing"
      ],
      project: "Implement AI tools in complete marketing workflow"
    },
    {
      module: 12,
      title: "Digital Marketing Strategy & Career Growth",
      duration: "2 weeks",
      topics: [
        "Integrated Digital Marketing Strategy",
        "Budget Planning & Allocation",
        "Agency vs In-House Marketing",
        "Building Your Personal Brand",
        "Freelancing & Consulting",
        "Interview Preparation & Portfolio Building"
      ],
      project: "Present complete digital marketing strategy to panel"
    }
  ],
  threeMonths: [
    {
      module: 1,
      title: "Digital Marketing Foundations",
      duration: "1 week",
      topics: [
        "Introduction to Digital Marketing Ecosystem",
        "Marketing Funnel & Customer Journey",
        "Digital Marketing Strategy Basics"
      ],
      project: "Create basic digital marketing strategy"
    },
    {
      module: 2,
      title: "Search Engine Optimization (SEO)",
      duration: "2 weeks",
      topics: [
        "On-Page SEO Fundamentals",
        "Keyword Research & Content Optimization",
        "SEO Tools & Google Search Console"
      ],
      project: "Basic SEO audit and implementation"
    },
    {
      module: 3,
      title: "Search Engine Marketing (SEM) & PPC",
      duration: "2 weeks",
      topics: [
        "Google Ads Fundamentals",
        "Campaign Setup & Management",
        "Keyword Strategy & Ad Copywriting"
      ],
      project: "Launch basic Google Ads campaign"
    },
    {
      module: 4,
      title: "Social Media Marketing",
      duration: "2 weeks",
      topics: [
        "Facebook & Instagram Marketing",
        "Content Creation Basics",
        "Social Media Analytics"
      ],
      project: "Create 15-day social media campaign"
    },
    {
      module: 5,
      title: "Content Marketing",
      duration: "2 weeks",
      topics: [
        "Content Strategy Basics",
        "Blog Writing & SEO Content",
        "Email Marketing Fundamentals"
      ],
      project: "Develop content marketing plan"
    },
    {
      module: 6,
      title: "Social Media Advertising & Analytics",
      duration: "3 weeks",
      topics: [
        "Facebook Ads Manager Basics",
        "Google Analytics Setup",
        "Campaign Tracking & ROI Basics"
      ],
      project: "Run social media ad campaign and analyze results"
    }
  ]
};

export const courseHighlights = [
  {
    icon: "Users",
    title: "Industry Expert Mentors",
    description: "Learn from professionals working at Google, Meta, Amazon, Flipkart"
  },
  {
    icon: "Award",
    title: "3 Industry Certifications",
    description: "Google, Meta & LinkedIn certified upon completion"
  },
  {
    icon: "Briefcase",
    title: "Real Client Projects",
    description: "Work on live projects with real brands and startups"
  },
  {
    icon: "Clock",
    title: "Flexible Learning",
    description: "Self-paced videos + live weekend sessions"
  },
  {
    icon: "Target",
    title: "Job Placement Support",
    description: "Resume building, interview prep, job referrals"
  },
  {
    icon: "TrendingUp",
    title: "Career Growth",
    description: "Average salary increase of 40-60% post-course"
  }
];

export const learningOutcomes = [
  "Master 10+ digital marketing channels and tools",
  "Create and execute data-driven marketing campaigns",
  "Achieve Google, Meta & LinkedIn certifications",
  "Build a professional portfolio with 5-10 real projects",
  "Understand marketing analytics and ROI measurement",
  "Learn AI-powered marketing automation",
  "Get job-ready with interview preparation",
  "Join EduSocial's exclusive alumni network"
];

export const toolsCovered = [
  "Google Ads", "Google Analytics 4", "Google Tag Manager",
  "Facebook Ads Manager", "Instagram Business Suite", "LinkedIn Campaign Manager",
  "SEMrush", "Ahrefs", "Moz",
  "HubSpot", "Mailchimp", "Zapier",
  "Canva", "Figma", "Adobe Creative Suite",
  "ChatGPT", "Copy.ai", "Jasper AI",
  "Hootsuite", "Buffer", "Sprout Social"
];

export const faqs = [
  {
    question: "Do I need prior marketing experience?",
    answer: "No prior experience required! Our program starts from basics and gradually moves to advanced topics. Whether you're a student, working professional, or entrepreneur, this course is designed for all levels."
  },
  {
    question: "What certifications will I receive?",
    answer: "Upon completion, you'll receive: 1) EduSocial Digital Marketing Certificate, 2) Google Digital Marketing Certification, 3) Meta Blueprint Certification, 4) LinkedIn Marketing Certification. All certificates are industry-recognized and can be added to your LinkedIn profile."
  },
  {
    question: "Is EMI option available?",
    answer: "Yes! We offer flexible EMI options. 6-month program: ₹16,666/month for 6 months. 3-month program: ₹16,666/month for 3 months. Zero-cost EMI available with select partners."
  },
  {
    question: "What is the time commitment?",
    answer: "6-month program: 8-10 hours/week. 3-month program: 12-15 hours/week. Includes self-paced video lectures, live sessions on weekends, and project work. All sessions are recorded for flexibility."
  },
  {
    question: "Will I get placement assistance?",
    answer: "Yes! The 6-month program includes dedicated placement support: resume building, LinkedIn profile optimization, mock interviews, and job referrals to 50+ partner companies. 3-month program includes basic career guidance."
  },
  {
    question: "What's the difference between 3-month and 6-month programs?",
    answer: "3-month program covers first 6 modules (fundamentals + core skills). 6-month program includes all 12 modules with advanced topics like AI in marketing, e-commerce, influencer marketing, plus more projects, 1-on-1 mentoring, and job placement assistance."
  },
  {
    question: "Can I access course material after completion?",
    answer: "6-month program: Lifetime access to all course materials, updates, and community. 3-month program: 6 months of access. You can upgrade anytime to get lifetime access."
  },
  {
    question: "Are the projects with real companies?",
    answer: "Yes! We partner with startups, SMEs, and select brands. You'll work on real marketing challenges under mentor guidance. Your work may actually be implemented by these companies, giving you genuine experience."
  }
];
